module.exports = __webpack_public_path__ + "img/money-1.b4f48d82.png";